module.exports = __webpack_public_path__ + "static/media/YF06_1.aa6eab0c.jpg";